
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from '../../../../../core/material';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WarningComponent } from '../../../../../shared/components/warning/warning.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzAutocompleteModule, NzCheckboxModule, NzInputModule, NzSpinModule, NzTableModule, NzTabsModule, NzTagModule, NzTreeModule } from 'ng-zorro-antd';
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import { EnterpriseActionLogComponent } from './enterprise-action-log.component';
import { EnterpriseActionLogRoutingModule } from './enterprise-action-log-routing.module';

@NgModule({
  declarations: [
  EnterpriseActionLogComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    EnterpriseActionLogRoutingModule,
    MaterialModule,
    TranslateModule,
    SharedModule,
    NzTabsModule,
    NzTableModule,
    NzCheckboxModule,
    NzTagModule,
    NzTreeModule,
    MatButtonToggleModule,
    NzAutocompleteModule,
    NzInputModule,
    NzSpinModule
  ]
})
export class EnterpriseActionLogModule { }
